import React from 'react';

export default function KlimaDetails() {
  return (
    <>
      
    </>
  )
}
